/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Create_TitleInputs */

const en_settings_tickets_create_title = /** @type {(inputs: Settings_Tickets_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a Ticket`)
};

const zh_settings_tickets_create_title = /** @type {(inputs: Settings_Tickets_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交工单`)
};

/**
* | output |
* | --- |
* | "Submit a Ticket" |
*
* @param {Settings_Tickets_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_create_title = /** @type {((inputs?: Settings_Tickets_Create_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Create_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_create_title(inputs)
	return zh_settings_tickets_create_title(inputs)
});
export { settings_tickets_create_title as "settings.tickets.create_title" }